<template>
  <div class="home-section">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">专家库</div>
        <div class="head-tips">Expert Database</div>
        <!-- <div @click="toList" class="head-more pointer">更多></div> -->
      </div>
      <div class="user" v-loading="listLoading">
        <Expert
          v-for="(item, index) in lists"
          :key="index"
          :data="item"
          :eduMap="eduMap"
        >
        </Expert>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/css/swiper.css";
import { EDU_GRADE } from "@/constant/dict";
import { expertCate, expertList } from "@/api/expert.js";
import Expert from "@/components/Expert/index";
export default {
  name: "modular_expert",
  components: { Expert },
  data() {
    return {
      cates: [],
      lists: [],
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      listLoading: false,
      eduMap: {},
      swiperOption: {
        slidesPerView: 4,
        autoplay: {
          delay: 2000,
        },
        loop: true,
      },
    };
  },
  created() {
    this.getDict();
    this.getType();
  },
  methods: {
    async getDict() {
      const res = await this.$store.dispatch("getDictData", EDU_GRADE);
      const eduMap = {};
      res.forEach((item) => {
        eduMap[item.dictValue] = item.dictLabel;
      });
      this.eduMap = eduMap;
    },
    async getType() {
      const data = await this.$axios.post(expertCate, {});
      this.cates = data;
      this.getList();
    },
    async getList() {
      this.listLoading = true;
      this.lists.length = 0;
      const { list } = await this.$axios
        .post(expertList, {
          ...this.page,
          expertPopStatus: "1", // 1：推荐，0：不推荐
          // fieldCategoryId: this.cates[0].fieldCategoryId,
        })
        .finally(() => {
          this.listLoading = false;
        });
      const result = list || [];
      this.lists = result;
    },
    toDetail(data) {
      this.$jump.push({ name: "expertsDetail", query: { id: data.expertId } });
    },
    toList() {
      this.$jump.push({ name: "expertsList" });
    },
  },
};
</script>
<style lang="scss" scoped>
.home-section {
  background: linear-gradient(to bottom, #e7f6fe, #f4fbff);
}
.user {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 15px));
  gap: 20px;
}
</style>
